import styled from '@emotion/styled';
import {Checkbox} from '@bosch/react-frok';

export const CheckboxStyled = styled(Checkbox)`
    padding-bottom: 1rem;
`;

export const DeleteInfoStyled = styled.div`
    min-height: 2rem;
    margin: 1rem 0 1rem 0;
`;